module.exports = __webpack_public_path__ + "img/ic-open-link-black.b690960a.svg";